import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { STATE_IDENTIFIER } from "./constants";

const {
  STEP_ONE,
  LOADER_IDENTIFIER,
  SOD_CONFLICTS,
  RESPONSE_STATE,
  CONFLICT_CREATION,
  CONFLICT_CREATION_SUMMARY,
  CONFLICT_DETAILS,
  EXCEPTION_MANAGEMENT,
  EXCEPTION_CREATION,
  SELECTED_CONFLICT,
  ALL_ENTITLEMENTS,
  SELECTED_ENTITLEMENTS,
  EXCEPTION_LIST,
  ALL_USERS,
  SELECTED_USERS,
  CONFLICT_TO_MODIFY,
} = STATE_IDENTIFIER;

export default {
  [STEP_ONE]: {
    [LOADER_IDENTIFIER]: false,
    [RESPONSE_STATE]: IResponseState.PENDING,
    [SOD_CONFLICTS]: [],
  },
  [CONFLICT_CREATION]: {
    [LOADER_IDENTIFIER]: false,
    [ALL_ENTITLEMENTS]: [],
    [SELECTED_ENTITLEMENTS]: [],
  },
  [CONFLICT_CREATION_SUMMARY]: {
    [RESPONSE_STATE]: IResponseState.PENDING,
  },
  [CONFLICT_DETAILS]: {
    [RESPONSE_STATE]: IResponseState.PENDING,
    [SELECTED_CONFLICT]: {},
  },
  [EXCEPTION_MANAGEMENT]: {
    [RESPONSE_STATE]: IResponseState.PENDING,
    [LOADER_IDENTIFIER]: false,
    [EXCEPTION_LIST]: [],
    [CONFLICT_TO_MODIFY]: "",
  },
  [EXCEPTION_CREATION]: {
    [RESPONSE_STATE]: IResponseState.PENDING,
    [LOADER_IDENTIFIER]: false,
    [ALL_USERS]: [],
    [SELECTED_USERS]: [],
  },
};
